import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { supabase } from '@/integrations/supabase/client';
import { scheduleKeys } from './queryKeys';
import { mapShiftRpcError } from '@/hooks/useSchedulingMutations';

/**
 * Dedicated hook for cancelling a shift offer (reclaiming a previously offered shift).
 */
export const useCancelOffer = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (shiftId: string) => {
      const { error } = await supabase.rpc('cancel_offer', { p_shift_id: shiftId });
      if (error) throw error;
    },

    onError: (error: any) => {
      const errorMessage = mapShiftRpcError(error?.message);
      toast.error(errorMessage);
    },

    onSuccess: () => {
      toast.success('Shift offer has been cancelled.');
    },

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
    },
  });
};
